import {Modal} from "react-bootstrap";
import React from "react";

interface ConfirmModalProps {
    title: string;
    message: string;
    buttons: string[];
    primaryBtn: string;

    onButtonClick: (title: string) => any;
    onClose: () => any;
}


export class ConfirmModal extends React.Component<ConfirmModalProps> {

    closeForm() {
        this.props.onClose();
    }

    clickButton(button: string) {
        this.props.onButtonClick(button);
    }


    render() {
        return (
            <>
                <Modal
                    style={{zIndex: 99999}}
                    show={true}
                    onHide={() => this.closeForm()}
                >
                    <Modal.Header closeButton style={{backgroundColor: "goldenrod"}}>
                        <Modal.Title>{this.props.title}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>{this.props.message}</p>
                    </Modal.Body>

                    <Modal.Footer>
                        {
                            this.props.buttons.map(
                                b => <button type={"button"} key={b}
                                             className={"btn" + (b === this.props.primaryBtn ? " btn-primary" : " btn-secondary") }
                                             onClick={() => this.clickButton(b)}>{ b }</button>
                            )
                        }
                    </Modal.Footer>
                </Modal>
            </>
        )
    }

}
